module.exports =  {
    header:{
            nav1:"Home",
            nav2:"Solutions",
            nav3:"Technology",
            nav4:"Downloads",
            nav5:"About Us",
            nav7:"Team",
            nav6:"Join Us",
            nav8:"VR Live/VOD",
            nav9:"VR Personal Webcasts",
            nav10:"High-Definition 2D Video",
            nav11:"Products",
            nav12:"VRVIU Cloud Service",
            nav13:"LightVR",
            nav14:"LightEncoder",
            nav15:"Player SDK",
            nav16:"Software Download",
            nav17:"SDK Download",
            navBtn:"More information"
          },
          text1:"Contact Us",
          text2:'Please leave your contact information,',
          text3:'we will contact you within 1 business day.<span style="color:#ff5959;vertical-align:middle">*</span>Required',
          text4:"Company Name",
          text5:'Full Name',
          text6:"Phone",
          text7:"Email Address",
          error:"Oops! Error occured, please try again later.",
          error503:"Oops! Error occured, please try again later.",
          error409:"Your submission has been received.",
          send:"Submit",
          text8:"Success",
          text9:"We've received your request, and will get in touch with you soon.",
          text10:"OK",
    join: {
      name:"Join Us",
      text1:"Everyone Can Enjoy<br>the Excitement of VR Live",
      text2:"Our revolutionary video compression and streaming technology will bring bandwidth-hungry video",
      text3:"to the global mass market while overcoming current internet infrastructure constraints.",
      text4:"Founding Team",
      text5:"Headquartered in Shenzhen, China, with a cutting-edge research lab in Silicon Valley, our core R&D members come from SIE, Tencent, Microsoft, and Harmonic. Applying our vast experience in VR, we have built a revolutionary VR live streaming technology that has truly advanced the well-established video streaming industry beyond imagination.",
      text6:"Finance",
      text7:"Stock options<br>401K match",
      text8:"Balance",
      text9:"Flexible work hours<br>Paid time off",
      text10:"Health",
      text11:"Sick & personal leave<br>Medical insurance",
      text12:'Create with VRVIU',
      text13:"At VRVIU, everyone is a creator. The flat management allows everyone’s voice to be heard while creating our VR dream together.",
      text14:"Learn and Grow",
      text15:'VRVIU cares about your personal growth. We offer a mentoring program, as well as the opportunity to work with industry leading experts in Silicon Valley.',
      text16:"Team"
    },
    footer:{
      text1:"Phone (General):  ",
      text2:'86 755 8695 6559',
      text3:'Phone (Business):',
      text4:"86 755 8696 0615",
      text5:'Email: ',
      text6:"business@vrviu.com",
      text7:'Address: 130 El Camino Real, Millbrae, CA 94030, USA<br>1-2 F, Tefa Info Tech Bldg, Qiongyu Rd, Nanshan, Shenzhen',
      text8:'<a href="http://www.vrviu.com/sdk/document/威尔云使用条款与法律声明.pdf" style="text-decoration: underline;color:#454545" download="威尔云使用条款与法律声明.pdf">Terms & Policies</a><br>© 2016-2018 VRVIU All Rights Reserved.'
    },
    features: {
      name:'Player SDK',
      banner_text:"Turn-key Solution for 8K",
      banner_text1:"VR Video Streaming",
      banner_button:"Free Download",
      text1: "Player SDK",
      text2: "Smooth streaming available 24/7",
      text3: "High performance, low power",
      text4: "Instant start-up, smooth playback",
      text5: "Cross-platform SDK",
      text6: "VR Video Player SDK",
      text7: "WebVR Video Player SDK",
      text8: "2D Video “High Resolution in Low Bandwidth” Player SDK",
      text9: "Support multiple face beautifying filters",
      text10: "2017.09.30: Push Stream Client SDK V0.6 officially released",
      text11: "Download",
      text12: 'VR Video Web Playback SDK',
      text13: 'Highly customized player UI',
      text14: "Support 360° 2D/3D, 180° 3D multi formats",
      text15: "Support drag&drop gestures and gyroscope <br>Support WeChat, QQ, Chrome, Safari and <br>main platforms",
      text16: "2018.03.08: Web VR Player SDK V1.0 officially released",
      text17: "FAQs",
      text18: "Is there a way to use VRVIU algorithm without the player SDK?",
      text19: "Our FE algorithm is highly efficient on the encoding side with the H.264/H.265 optimization. Accordingly, the player side also needs corresponding decoding. For these above reasons, the player side needs to use the VRVIU SDK.",
      text20: "How big is the app size increase after player SDK integration?",
      text21: "Our core SDK is approximately 1M. The final app size increase depends on both your choice of our product and your current app technology adoption.",
      text22: "Contact Us",
      text23: "Android",
      text111: "SDK Download",
      text112: "Documentation",
      text113: "Web Demo",
                table1: {
                        title: "VR Video Player SDK",
                        label1: "Maximum Resolutioin",
                        label11: "Audio/Video Codec",
                        label12: "Transmission Protocol",
                        label13: "Video Format",
                        label14: "Projection Format",
                        label15: "Playback Mode",
                        label16: "Decoding Mode",
                        label17: "Platform",
                        label18: "Chipset",
                        label19: "Devices",
                        label10: "Patented FE Algorithm",
                        text1: "VR video 8192*8192@60fps",
                        text102: "2D video 3840*3840@60fps",
                        text103: "",
                        text2: "H.264 | H.265 | AAC",
                        text3: "RTMP | HTTP MP4 | HTTP FLV | HLS",
                        text4: "180° 3D | 360° 2D | 360° 3D",
                        text5: "Equirectangular | Fisheye",
                        text6: "Live streaming | Video-on-Demand",
                        text7: "Hardware | Software",
                        text8: "ARMV7 | ARM64 | X86",
                        text9: "Qualcomm 820+ | Allwinner VR9 | Samgsung8890+",
                        text10: "GearVR | Oculus Go | XIAOMI | Pico | HTC VIVE | DPVR | 3Glasses | Cardboard",
                        text11: "Bandwidth save up to 75%，only need 20Mbps for 8K video"
                      },
                      table2: {
                        title: "WebVR Video Player SDK",
                        label1: "Maximum Resolutioin",
                        label2: "Audio/Video Codec",
                        label3: "Video Format",
                        label4: "Playback Mode",
                        label5: "Playback Operation",
                        label6: "Playback Platform",
                        label7: "UI",
                        label8: "Patented FE Algorithm",
                        text1: "3840*1920@30fps",
                        text2: "H.264 | H.265 | AAC",
                        text3: "180° 3D | 360° 2D | 360° 3D",
                        text4: "Live streaming | Video-on-Demand",
                        text5: "drag&drop gestures and gyroscope",
                        text6: "Support for mainstream web browser",
                        text7: "Customized based on needs",
                        text8: "Yes"
                      },
                      table3: {
                        title: "2D Video “High Resolution in Low Bandwidth” Player SDK",
                        label1: "Maximum Resolutioin",
                        label2: "Audio/Video Codec",
                        label3: "Playback Mode",
                        label4: "Decoding Mode",
                        label5: "Transmission Protocol",
                        label6: "Instant start-up",
                        label7: "Platform",
                        label8: "Patented FE Algorithm",
                        text1: "3840*2160",
                        text2: "H.264 | H.265 | AAC",
                        text3: "Live streaming | Video-on-Demand",
                        text4: "Hardware | Software",
                        text5: "RTMP | HTTP MP4 | HTTP FLV | HLS ",
                        text6: "First screen instant start-up",
                        text7: "Android | iOS | HTML5",
                        text8: "Bandwidth save up to 40%, 600Kbps for 720p@H.265"
                      }
    },
    about: {
      name:"About Us",
      text1:"Everyone Can Enjoy<br>the Excitement of VR Live",
      text2:"Our revolutionary video compression and streaming technology will bring bandwidth-hungry video",
      text3:"to the global mass market while overcoming current internet infrastructure constraints.",
      text4:"Team",
      text5:"Headquartered in Shenzhen, China, with a cutting-edge research lab in Silicon Valley, our core R&D members come from SIE, Tencent, Microsoft, and Harmonic. Applying our vast experience in VR, we have built a revolutionary VR live streaming technology that has truly advanced the well-established video streaming industry beyond imagination.",
      text6:"Founder & CEO",
      text7:"Co-Founder",
      text8:"CPO",
      text9:"Director of Human Resources",
      text10:"Join Us"
    },
    download: {
      title: "LightVR App",
      text: "Experience our quality 4K streaming in sporting events, concerts, and eSports through our demo."
    },
    index: {
      header: {
        nav1: "Home",
        nav2: "Solutions",
        nav3: "Technology",
        nav4: "Developer",
        nav5: "About Us",
        nav6: "Join Us",
        nav7: 'Team',
        navBtn: "Sign in",
        navBtn2: "Sign up",
        nav10: "VR Live/VOD",
        nav11: "VR Personal Webcasts",
        nav12: "High-Definition 2D Video",
        nav13: "Console",
        nav14: "Logout"
      },
      text1: "Contact Us",
      text2: 'Please leave your contact information,',
      text3: 'we will contact you within 1 business day.<span style="color:#ff5959;vertical-align:middle">*</span>Required',
      text4: "Company",
      text5: 'Name',
      text6: "Phone",
      text7: "Email",
      error: "Oops! Error occured, please try again later.",
      error503: "Oops! Error occured, please try again later.",
      error409: "Your submission has been received.",
      send: "Submit",
      text8: "Success",
      text9: "We've received your request, and will get in touch with you soon.",
      text10: "OK"
    },
    product: {
      name: "LightVR",
      banner_text: "Turn-key Solution for 8K ",
      banner_text2: 'VR Video Streaming',
      banner_botton: "Free Download ",
      introduction_title: "LightVR 8K Player",
      introduction_text11: "Enjoy quality 8K VR video either streaming online or playing offline",
      introduction_text12: "Bring iMax big screen and Ultra HD video to VR",
      introduction_text13: "Switch between multiple playlists adapted to various scenarios",
      introduction_title2: "LightVR Wechat Mini-Program",
      introduction_title3: "Key Functions",
      introduction_text2: "Experience VR video with Wechat",
      introduction_text21: "Enjoy 4K quality VR on mobile phone",
      introduction_text22: "Play by video id or playlist id",
      introduction_text23: "Support VR mode and Full-screen mode",
      introduction_text24: "Share with friends",
      introduction_title4: "Supported devices",
      platform_pic1: "Cardboard",
      platform_pic2: "Pico",
      platform_pic3: "小米VR",
      platform_pic4: "HTC Vive",
      platform_pic5: "Oculus",
      platform_pic6: "微信小程序",
      introduction_title5: 'Want to customize player?',
      text45: "Contact Us"
    },
    technology: {
      name:"Technology",
      text1:'Patented FE (Foveated Encoding) Algorithms',
      text2:"Patented FE (Foveated Encoding) <br>Algorithms",
      text3:'VRVIU invented a multi-layer based view adaptation scheme based on foveal vision,with more efficient compression, faster view switch, less bandwidth waste and smoother network traffic.',
      text4:"VR Videos，",
      text5:'Bandwidth Saved <br>Up to 70%',
      text6:"Upload Bandwidth savings of 70%",
      text7:"will ease the uploading of 4K VR personal webcasts.",
      text8:"2D Videos,",
      text9:"600Kbps for 720p",
      text10:'Download Bandwidth savings of 70%',
      text11:"will enable smooth 4K+ VR on mobile connections.",
      text12:'Zero-perceived',
      text13:"View Switching Latency",
      text14:"Stable, 24/7, high concurrent streaming",
      text15:"at a large scale, ultra-low network round",
      text16:'trip latency required for interactive',
      text17:"personal webcasts.",
      text18:"Intelligent Codec,",
      text19:'Machine Learning on Cloud',
      text20:"VRVIU Cloud can smartly select the best suitable algorithm based<br>on the video content. The more data input,the more efficient the<br>codec become.",
      text21:'',
      text22:'',
      text23:"Our Patented Audio Streaming<br>Technology Dynamically Reproduces<br>3D Sound in VR",
      text24:'Cloud-based audio encoding scheme uniquely produces low bit rates with high fidelity 3D live sound in VR.',
      text25:"Try Demo",
      text26:"Experience our quality 4K streaming in sporting events, concerts, and eSports through our demo.",
      text27:'Try Demo',
      text28:"Learn More",
      text30:'Every pixel is treated <br>equally',
      text31:"Dynamically distribute pixels<br> based on foveal vision",
      text32:'Learn more about FE algorithms:<br> <a href="https://www.vrviu.com/sdk/document/Improving Network Bandwidth Usage with Foveated encoding(1).pdf" target="_blank" style="color:#0084ff">Improving Network Bandwidth Usage with Foveated encoding.pdf</a>'
    },
    solution3: {
        name:"High-Definition 2D Video",
        name1:"VR Live/VOD",
        name2:"VR Personal Webcasts",
        banner_text:"Lower Bandwidth Cost<br>Better Streaming Experience",
        banner_botton:"Try Demo",
        title1:'High-Definition 2D Video: 600Kbps for 720P, Smoother Playback',
        text1:'Tailored for personal webcasts and FPS games, VRVIU helps you save bandwidth cost up to 40% with our intelligent codec.',
        text2:"",
        text3:"VRVIU Cloud",
        text4:'Personal Webcasts',
        text5:'Our VR personal webcasts offer many popular options such as built-in, real-time beautification filters and digital makeup.',
        text6:"Video Clips",
        text7:'Experience live sports events in ways you never could before!',
        text8:"Live Games",
        text9:'Your front row seat for live concerts in VR',
        text10:'360° VR: Zero-perceived View<br>Switching Latency',
        text11:'For larger events such as concerts, eSports, sporting<br>events, or tourism experiences, 360° VR livestreaming<br>brings the experience of "being there".',
        text12:'',
        text46:"",
        text13:"Personal Webcasts",
        text14:"Viewers will enjoy the panoramic battlefield view by bringing 360° views to traditional 2D eSports.",
        text15:'Video Clips',
        text16:'Experience live news in the field with 360° views.',
        text17:'Live Games',
        text18:'VR Live Travel: Climb mountains, dive into deep waters, and tour the world with your travel host.',
        text19:"VRVIU Cloud Main Features",
        text20:'Low Bandwidth',
        text21:'Bandwidth requirements<br>reduced by 70%',
        text22:'Standard Protocols',
        text23:'Patented “zero-perceived<br>latency” technology',
        text24:'Low Cost',
        text25:'Intelligent video decoding<br>on low-end mobile phones',
        text26:'Instant Startup',
        text27:'Support for RTMP,<br>DASH, and HLS',
        text28:"Low Power",
        text29:'highly concurrent,<br>7x24 stable streaming',
        text30:'Cross-platform',
        text31:"Support Android,<br>iOS, HTML5 and Gear VR",
        text32:"Technology",
        text33:'Cross-platform',
        text34:'Free Trial',
        text35:'FAQs',
        text36:"What are the recommended scenarios for VRVIU high-definition 2D video turn-key solution?",
        text37:"Our 2D solution can maximum its effort for contents having foveal vision, for example, personal webcasts and FPS games.",
        text38:"Does the solution support codec compression within the push stream software?",
        text39:"VRVIU currently only supports codec compression on cloud.",
        text40:"How does codec work?",
        text41:"VRVIU supports multi bitrates formats and resolutions for compressed content, and single bitrates and resolution for non-compressed content. And it allows you to turn on and off for different contents and time slots, saving your bandwidth cost at a maximum level.",
        text42:"Does VRVIU support H.265 Codec?",
        text43:"VRVIU supports both H.264 and H.265 codec.",
        text44:"More questions?",
        text45:"Contact Us",
        text47:"Does it support Web/H5 streaming or live?",
        text48:"VRVIU's WebPlayer supports both VOD and live contents."

      },
    solution2: {
        name:"VR Personal Webcasts",
        name1:"VR Live/VOD",
        name2:"High-Definition 2D Video",
        banner_text:"70% Less Upload Bandwidth, Enable 4K VR Live From Home Internet",
        banner_botton:"Try Demo",
        title1:'Personal VR Webcasts: Fully Immersive Real-time Interaction',
        text1:'180° 3D webcast delivers a stunning immersive and intimate experience. Our unique wide-angle video encoding technology compresses 4K+ 3D  video at less than 720p bitrate for a smooth webcast.',
        text2:"",
        text3:"VRVIU Cloud",
        text4:'VR Live-show',
        text5:'Our VR personal webcasts offer many popular options such as built-in, real-time beautification filters and digital makeup.',
        text6:"VR Sports",
        text7:'Experience live sports events in ways you never could before!',
        text8:"VR eSports",
        text9:'Your front row seat for live concerts in VR',
        text10:'360° VR: Zero-perceived View<br>Switching Latency',
        text11:'For larger events such as concerts, eSports, sporting<br>events, or tourism experiences, 360° VR livestreaming<br>brings the experience of "being there".',
        text12:'',
        text46:"",
        text13:"VR eSports",
        text14:"Viewers will enjoy the panoramic battlefield view by bringing 360° views to traditional 2D eSports.",
        text15:'VR Live News',
        text16:'Experience live news in the field with 360° views.',
        text17:'VR Live Travel',
        text18:'VR Live Travel: Climb mountains, dive into deep waters, and tour the world with your travel host.',
        text19:"VRVIU Cloud Main Features",
        text20:'Low Bandwidth',
        text21:'Bandwidth requirements<br>reduced by 70%',
        text22:'Low Latency',
        text23:'Patented “zero-perceived<br>latency” technology',
        text24:'Low Power',
        text25:'Intelligent video decoding<br>on low-end mobile phones',
        text26:'Standard Protocols',
        text27:'Support for RTMP,<br>DASH, and HLS',
        text28:"Reliable Service",
        text29:'highly concurrent,<br>7x24 stable streaming',
        text30:'Cross-platform',
        text31:"Support Android,<br>iOS, HTML5 and Gear VR",
        text32:"Technology",
        text33:'Cross-platform',
        text34:'Free Trial',
        text35:'FAQs',
 text36:"For VR personal webcasts, is there any requirement for the upload bandwidth?",
        text37:"With VRVIU Push Stream and Player SDKs, the upload bandwidth is down to 2Mbps ~ 4Mbps.",
        text38:"Can we use our private broadcaster software for live streaming?",
        text39:"Based on open source software OBS, VRVIU redesigns and tailors OBS to VBS just for VR webcast streamers. if you want to integrating VRVIU SDK to your software,please contact us for further details.",
        text40:"Does it support Web/H5 streaming/playback?",
        text41:"VRVIU WebVR player has been developed for easy sharing and smooth playback.You can try our web demo and SDK for free.",
        text42:"Do you have any recommended 180° 3D VR camera?",
        text43:'VRVIU supports <a href="http://www.z-cam.com/180-vr-camera-k1-pro/" target="_blank" style="color:#0078e7">ZCAM K1 Pro</a> for our VR webcast solution. Google VR180 project also has some recommendations , such as <a href="http://www.yitechnology.com/180-vr-camera" target="_blank" style="color:#0078e7">YI Horizon VR180</a> ',
        text44:"More questions?",
        text45:"Contact Us"
      },
    product2: {
      name:"LightEncoder",
      banner_text: "Turn-key Solution for 8K ",
      banner_text1: 'VR Video Streaming',
      banner_botton: 'Download',
      introduction_title: "Key Functions",
      introduction_text1: "Offline transcoder using laptop or PC,",
      introduction_text2: "Eliminating the long waits for uploads and downloads",
      introduction_text3: "Customize the start and end time of video for transcoding",
      introduction_text44: "Support transcoding queues to maximize the capacity",
      introduction_title2: "System Requirements",
      introduction_text4: "CPU: Intel Core i5 processors 4 cores 3.0GHz+",
      introduction_text5: "RAM: 16 GB of system memory or above",
      introduction_text6: "Storage：100GB or above ",
      introduction_text7: "OS：Windows 7 64-bit or Windows 10 64-bit",
      text25: "Try LightEncoder",
      text26: "LightEncoder is now in beta stage",
      text28: "Please contact us for licence key to try it immediately",
      text29: "",
      text27: "Contact Us"
    },

    product3: {
      name:"VRVIU Cloud Service",
      banner_text: "Turn-key Solution for 8K ",
      banner_text1: "VR Video Streaming",
      banner_botton: "Try Now",
      introduction_title: "Key Functions",
      text20: "Support Input Video Format",
      text21: "VR 180/360, mono and stereo",
      text22: "Resolution between 3K and 8K",
      text23: "Input Codec of H.264, H.265 and VP9",
      text24: "File Size less than 10GB",
      text30: "Multiple Output Video Quality",
      text31: "FE 6K/8K provide ultimate experience",
      text32: "FE 3K/4K for online streaming",
      text33: "Standard 2.5K/3K/4K for web player",
      text40: "Content Management",
      text41: "Video editing, publishing and streaming",
      text42: "Customize playlists for business needs",
      text43: "Download 6K/8K videos and play offline",
      introduction_title2: "Why Choose Us",
      platform_pic1: "Patented FE Algorithms",
      platform_pic11: "Switching without latency",
      platform_pic12: "provide 8K VR experience",
      platform_pic2: "Support Input Format",
      platform_pic21: "VR 180/360, mono and stereo",
      platform_pic22: "Codec of H.264 | H.265 | VP9",
      platform_pic3: "Multiple Output Quality",
      platform_pic31: "FE for Ultimate experience",
      platform_pic32: "MP4 for standard player",
      platform_pic4: "Turn-key Management",
      platform_pic41: "Video editing & publishing",
      platform_pic42: "Playlists for business needs",
      text25: "Free Trial of VRVIU Cloud",
      text26: "Register and quickly experience the adavantages of",
      text27: "Try Now",
      text29:"VRVIU Cloud in transcoding bandwidth saving and smooth playback",
      text28: 'Check the<a href="" style="text-decoration: underline;  display: inline-block;vertical-align: middle;color:#fff;margin-bottom:4px;margin-left:5px;">help documentation</a>，for more questions<a href="" style="margin-left:5px;text-decoration: underline; margin-bottom:4px; display: inline-block;vertical-align: middle;color:#fff;">contact us</a>'

    },
    home: {
     index:{
            banner_title:'8K VR Video Player',
            banner_text:'New Immersive Experience',
            notice:'2018.12.10: LightEncoder V1.1 released',
            title1:"VRVIU Cloud: The Turn-key Solution for HD Video Streaming in Low Bandwidth",
            vrviu:'Learn More',
            item_title1:'Push HD <br>Boundaries',
            item_title2:'Save 70% <br>Bandwidth',
            item_title3:'Multi Scenes<br> Support',
            item_title4:'Stable Live <br>Service',
            item_text1:'Enjoy the ultimate immersive<br>experience by streaming<br>in 4K to 8K resolution',
            item_text2:'Deliver uncompromised 4K+ VR<br>streaming on mobile<br>while using 70% less data',
            item_text3:'Choose between 180º 3D<br>or 360º panoramic<br>setups to suit your content',
            item_text4:'Highly concurrent 7x24<br>smooth streaming<br>low-latency and cross-platform',
            pic_text1:'VR Personal Webcasts',
            pic_text2:'eSports VR',
            pic_text3:'VR Sports',
            pic_text4:'VR Show',
            pic_text5:'VR News',
            title2:'Various Application Scenarios',
            title3:'Seeing Is Believing',
            download_title:'View the sample 4 Mbps video, we recommend full-screen mode for more detailed comparisons.',
            download_title2:'Video source：<a href="https://www.amaze.us" class="dance_link" target="_blank">AMAZE VR | Dance with Magga</a>',
            try_download:'Try LightVR 8K Player',
            try_download_text:'Enjoy true immersive experience of  our quality 8K contents.',
            try_download_btn:'Download',
            try_free:'Try Free',
            try_free_text:'Try our VRVIU Cloud to fully experience our  ',
            try_free_text2:'superior technologies in intelligent video encoding,smooth streaming, and low power playback.',
            try_free_btn:'More information',
            friends:"Cooperative Partner"
          },
          download:'More information',
          text4:"Personal Webcasts",
          text5:"Live Games",
          text6:"Video Clips"
    },
    solution: {
        name:"VR Live/VOD",
        name1:"VR Personal Webcasts",
        name2:"High-Definition 2D Video",
        banner_text:"Say Goodbye to Blocky Images <div style='font-family: Quicksand Regular'>and Redefine VR Live</div>",
        banner_botton:"Try Demo",
        title1:'180° 3D / 360° VR: Zero-perceived View Switching Latency',
        text1:'180° 3D VR streaming delivers a stunning immersive and intimate experience, while 360° VR brings you the wholeexperience of concerts,sporting events or tourist attractions. VRVIU’s cloud-based intelligent video encoding technology offers unmatched 4K+ quality over a mobile connection with only the data cost of 720p.',
        text2:"",
        text3:"VRVIU Cloud",
        text4:'VR Live-show',
        text5:'Our VR personal webcasts offer many popular options such as built-in, real-time beautification filters and digital makeup.',
        text6:"VR Sports",
        text7:'Experience live sports events in ways you never could before!',
        text8:"VR eSports",
        text9:'Your front row seat for live concerts in VR',
        text10:'360° VR: Zero-perceived View<br>Switching Latency',
        text11:'For larger events such as concerts, eSports, sporting<br>events, or tourism experiences, 360° VR livestreaming<br>brings the experience of "being there".',
        text12:'',
        text46:"",
        text13:"VR eSports",
        text14:"Viewers will enjoy the panoramic battlefield view by bringing 360° views to traditional 2D eSports.",
        text15:'VR Live News',
        text16:'Experience live news in the field with 360° views.',
        text17:'VR Live Travel',
        text18:'VR Live Travel: Climb mountains, dive into deep waters, and tour the world with your travel host.',
        text19:"VRVIU Cloud Main Features",
        text20:'Low Bandwidth',
        text21:'Bandwidth requirements<br>reduced by 70%',
        text22:'Low Latency',
        text23:'Patented “zero-perceived<br>latency” technology',
        text24:'Low Power',
        text25:'Intelligent video decoding<br>on low-end mobile phones',
        text26:'Standard Protocols',
        text27:'Support for RTMP,<br>DASH, and HLS',
        text28:"Reliable Service",
        text29:'highly concurrent,<br>7x24 stable streaming',
        text30:'Cross-platform',
        text31:"Support Android,<br>iOS, HTML5 and Gear VR",
        text32:"Technology",
        text33:'Cross-platform',
        text34:'Free Trial',
        text35:'FAQs',
        text36:"Why do we choose VRVIU SDKs?",
        text37:"There are 2 versions of our SDK: Free version provides smooth playback of high quality VR streaming, while the paid version allows you to experience 4K low-latency VR videos with the data cost of 720p. You can download and try our free SDK, or contact us for more information about the paid version.",
        text38:"We’re already using the public cloud live treaming service. Will this stop us from integrating VRVIU Cloud VR live streaming service?",
        text39:"VRVIU supports multi CDN providers, public and private deployment. And you can decide when or which videos to use our service based on your own needs, so as to experience 4K VR at a 720p bandwidth.",
        text40:"What's the time cost of integrating VRVIU Cloud service?",
        text41:"It takes 2 minutes with supported standard protocols.",
        text42:"Is there any latency after VRVIU Cloud integration?",
        text43:"The latency is equal to or less than 1 second within VRVIU Cloud system, and there's no volatility during the view switching process. The live streaming transmission latency is determined by video stream codec parameters and the network environment.",
        text44:"More questions?",
        text45:"Contact Us"
      },
    devolop: {
      name:"SDK Download",
      title1: "SDK Download",
      title2: "VR Video Player SDK",
      title3: "(VRVIU BitPlayer SDK)",
      title4: "Unity",
      version1: "Version：V2.8",
      date1: "updated：2018.11.08",
      button1: "Documentation",
      button2: "SDK download",
      title55: "HTML5",
      version2: "updated：2018.05.17",
      date2: "2018.07.27",
      title5: "High-Definition 2D Player SDK",
      title6: "（VRVIU AltPlayer SDK）",
      title7: "iOS",
      version3: "Version：V1.3",
      date3: "updated：2018.04.19",
      title8: "Android",
      Version4: "Version：V1.3",
      date4: "updated：2018.04.28",
      title9: "HTML5",
      version5: "Version：V1.0",
      date5: "updated：2018.05.07",
      title10: "4K VR Personal Webcasts Software",
      title11: "（VBS）",
      title12: "Install on PC",
      version6: "Version：V1.0",
      date6: "updated：2018.05.11",
      title13: "View on Android phone",
      version7: "Version：Android V1.0",
      date7: "updated：2018.05.04",
      button3: "Try now",
      button4: "Download",
      button5: "Coming Soon",
      title14: "LightVR App",
      title15: "（Download to experience our quality 4K VR video streaming）",
      title16: "Cardboard for Android",
      Version8: "Version：V1.2",
      date8: "updated：2018.05.02",
      title17: "Cardboard for iOS",
      version9: "",
      date9: ""
    },
    software: {
      name:"Software Download",
      download: "download",
      banner_text: "Software Download",
      introduction_title: "LightVR App",
      introduction_title2: "Experience our quality 8K  VR video <br>streaming of VRVIU Cloud",
      product_title1: "Cardboard<span class='platform_info2'>（Android）</span>",
      product_vison1: "Version：2.5",
      product_date1: "updated：2018-10-19",
      product_title2: "LightVR for Pico",
      product_vison2: "Version：2.5",
      product_date2: "updated：2018-11-05",
      product_title3: "Mini Program",
      product_vison3: "Version：2.1",
      product_date3: "updated：2018-11-26",
      product_title4: "LightVR for Vive",
      product_vison4: "Coming soon",
      product_date4: "",
      product_title5: "LightVR for Oculus",
      product_vison5: "Coming soon",
      product_date5: "",
      product_title6: "LightVR for MiVR",
      product_vison6: "Coming soon",
      product_date6: "",
      introduction_title3: "LightEncoder",
      introduction_title4: "（8K VR-Video Transcoding Tool)",
      product_title7: "LightEncoder<span class='platform_info2'>（Windows）</span>",
      product_vison7: "Version：1.1",
      product_date7: "updated：2018-12-10",
      product_title8: "LightEncoder<span class='platform_info2'>（Linux）</span>",
      product_vison8: "Coming soon",
      product_date8: "",
      introduction_title5: "VBS",
      introduction_title6: "VR Personal Webcast Software",
      product_title9: "VBS for Windows",
      product_vison9: "Version：1.0",
      product_date9: "updated：2018-05-11",
      product_title10: "View on Android Phone",
      product_vison10: "Version：1.0",
      product_date10: "updated：2018-05-11",
      introduction_text: "LightEncoder is now in the beta stage，and can be activated<br> with license key Please contact us to get the key"

    }


}




//////////////////
// WEBPACK FOOTER
// ./static/js/en.js
// module id = 110
// module chunks = 0